import { Picture, Source } from "~/components/ui/Picture"
import Image from "~/components/ui/Image"

interface ImageProp {
    /**
     * @title Imagem
     */
    src: string
    /**
     * @title Texto Alternativo
     */
    alt: string
}

export interface Props {
    /**
     * @title Imagem de Fundo
     */
    backgroundImage: ImageProp
}

export default function BackgroundPicture({
    backgroundImage,
}: Props) {
    return (
        <Picture>
            <Source media='(max-width: 767px)' src={backgroundImage.src} width={206} height={187} />

            <Source media='(min-width: 768px)' src={backgroundImage.src} width={362} height={327} />

            <Image
                className='w-full h-full object-fill absolute inset-0 top-0 left-0 z-0'
                src={backgroundImage.src}
                alt={backgroundImage.alt}
                width={362}
                height={327}
                fetchPriority='low'
                loading='lazy'
            />
        </Picture>
    )
}
